import { Box, Button, Divider, Grid, Typography } from '@mui/material';
import { useState } from 'react';
import { useAppSelector } from '../../Redux/store';
import { EditPasswordModal } from './Components/Password/EditPasswordModal';
import { KaziLayout } from '../../Shared Components/Kazi/Layouts/KaziLayout';

export const PasswordSettings = () => {
    /* ******************** Hooks ******************** */
    const userId = useAppSelector( state => state.Global.userId);
    /* ******************** Variables ******************** */
    const [open, setOpen] = useState(false);
    /* ******************** Functions ******************** */
    /* ******************** Effects ******************** */
    /* ******************** JSX ******************** */
    return (
        <>
            <KaziLayout
            >
                <Typography variant="lora-headline-small">Password</Typography>
                <Grid display={"flex"} flexDirection={"column"}  marginTop={'28px'}>
                    <Grid display={"flex"} flexDirection={"column"} width={'100%'}> 
                        <Grid display={"flex"} flexDirection={"row"}  marginBottom={1}>
                            <Typography variant='body-medium' marginRight={30} flex={1}>Password has been set</Typography>
                            <Grid display={"flex"} flexDirection={"row"} gap={"40px"}  flex={1} justifyContent={'flex-end'}>
                                {/* <Button variant='text'>Delete account</Button> */}
                                <Button variant='outlined' onClick={() => setOpen(true)}>Edit</Button>
                            </Grid>
                        </Grid>
                        <Divider />
                    </Grid>
                </Grid>
            </KaziLayout>
            <EditPasswordModal 
                open={open} 
                setOpen={setOpen} 
                userId={userId}
            />
        </>
    )
}